
import { ApiService } from '..';

export const AuthenticationService = {

    login(data) {
        return ApiService.login(data);
    },

    logout() {
        return ApiService.logout();
    },
};

